/**
 * ============================================
 * HOMEPAGE PARALLAX - NOMARBLE
 * Script pour l'effet parallaxe au scroll
 * ============================================
 */

(function() {
  'use strict';

  /**
   * Configuration de l'effet parallaxe
   * Les valeurs correspondent à la vitesse de déplacement de chaque section
   * Plus la valeur est élevée, plus la section se déplace rapidement
   */
  const PARALLAX_CONFIG = {
    space: 0.1,      // Section espace - Déplacement lent
    stars: 0.08,     // Section étoiles - Un peu plus lent
    clouds: 0.06,    // Section nuages - Encore plus lent
    dunes: 0.04,     // Section dunes - Le plus lent
    starsLayer: 0.03 // Couche d'étoiles supplémentaire - Très lent
  };

  /**
   * Détection du support de requestAnimationFrame
   * Utilise requestAnimationFrame pour de meilleures performances
   * Sinon, utilise setTimeout comme fallback
   */
  const requestAnimFrame = window.requestAnimationFrame ||
                           window.webkitRequestAnimationFrame ||
                           window.mozRequestAnimationFrame ||
                           function(callback) {
                             window.setTimeout(callback, 1000 / 60);
                           };

  /**
   * Variables pour stocker les éléments DOM
   */
  let spaceSection = null;
  let starsSection = null;
  let cloudsSection = null;
  let dunesSection = null;
  let starsElement = null;

  /**
   * Variable pour optimiser les performances
   * Évite de recalculer le parallaxe à chaque frame si non nécessaire
   */
  let isScrolling = false;
  let lastScrollPosition = 0;

  /**
   * Initialisation du script
   * Appelée au chargement du DOM
   */
  function init() {
    // Récupération des éléments DOM
    spaceSection = document.querySelector('.space-section');
    starsSection = document.querySelector('.stars-section');
    cloudsSection = document.querySelector('.clouds-section');
    dunesSection = document.querySelector('.dunes-section');
    starsElement = document.querySelector('.stars');

    // Vérifier que les éléments existent avant d'ajouter les événements
    if (!spaceSection || !starsSection || !cloudsSection || !dunesSection) {
      console.warn('Nomarble Parallax: Certaines sections ne sont pas trouvées');
      return;
    }

    // Écouteur d'événement pour le scroll
    window.addEventListener('scroll', onScroll, { passive: true });

    // Déclencher un calcul initial
    updateParallax();

    console.log('Nomarble Parallax: Initialisé avec succès');
  }

  /**
   * Fonction appelée lors du scroll
   * Utilise requestAnimationFrame pour optimiser les performances
   */
  function onScroll() {
    if (!isScrolling) {
      isScrolling = true;
      requestAnimFrame(updateParallax);
    }
  }

  /**
   * Fonction principale : calcul et application de l'effet parallaxe
   */
  function updateParallax() {
    // Récupérer la position de scroll actuelle
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Optimisation : ne rien faire si la position n'a pas changé
    if (scrollPosition === lastScrollPosition) {
      isScrolling = false;
      return;
    }

    lastScrollPosition = scrollPosition;

    /**
     * APPLICATION DE L'EFFET PARALLAXE
     * Chaque section se déplace à une vitesse différente
     * Créant ainsi l'illusion de profondeur
     */

    // Section ESPACE - Se déplace le plus rapidement
    if (spaceSection) {
      const spaceTransform = scrollPosition * PARALLAX_CONFIG.space;
      spaceSection.style.transform = `translateY(${spaceTransform}px)`;
    }

    // Section ÉTOILES - Déplacement moyen-rapide
    if (starsSection) {
      const starsTransform = scrollPosition * PARALLAX_CONFIG.stars;
      starsSection.style.transform = `translateY(${starsTransform}px)`;
    }

    // Section NUAGES - Déplacement moyen-lent
    if (cloudsSection) {
      const cloudsTransform = scrollPosition * PARALLAX_CONFIG.clouds;
      cloudsSection.style.transform = `translateY(${cloudsTransform}px)`;
    }

    // Section DUNES - Se déplace le plus lentement
    if (dunesSection) {
      const dunesTransform = scrollPosition * PARALLAX_CONFIG.dunes;
      dunesSection.style.transform = `translateY(${dunesTransform}px)`;
    }

    // Effet parallaxe supplémentaire pour la couche d'étoiles
    if (starsElement) {
      const starsLayerTransform = scrollPosition * PARALLAX_CONFIG.starsLayer;
      starsElement.style.transform = `translateY(${starsLayerTransform}px)`;
    }

    // Réinitialiser le flag de scroll
    isScrolling = false;
  }

  /**
   * Fonction de nettoyage
   * Supprime les écouteurs d'événements pour éviter les fuites mémoire
   */
  function destroy() {
    window.removeEventListener('scroll', onScroll);
    console.log('Nomarble Parallax: Nettoyé');
  }

  /**
   * GESTION DU RESPONSIVE
   * Désactive l'effet parallaxe sur mobile pour de meilleures performances
   */
  function checkMobile() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // Sur mobile, on peut désactiver l'effet parallaxe
      // ou le réduire pour économiser les ressources
      // Pour l'instant, on laisse actif mais vous pouvez décommenter :
      // destroy();
      // return false;
    }

    return true;
  }

  /**
   * Gestion du redimensionnement de la fenêtre
   */
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      checkMobile();
    }, 250);
  }, { passive: true });

  /**
   * DÉMARRAGE DU SCRIPT
   * Attend que le DOM soit complètement chargé
   */
  if (document.readyState === 'loading') {
    // DOM pas encore prêt
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM déjà prêt
    init();
  }

  /**
   * Nettoyage lors du déchargement de la page
   * Important pour Shopify qui peut charger/décharger des sections dynamiquement
   */
  window.addEventListener('beforeunload', destroy);

  /**
   * Support pour l'éditeur de thème Shopify
   * Réinitialise le parallaxe quand la section est rechargée dans l'éditeur
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId && event.target.querySelector('.nomarble-parallax-wrapper')) {
        // Attendre un peu que le DOM soit mis à jour
        setTimeout(init, 100);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail.sectionId) {
        destroy();
      }
    });
  }

  /**
   * Exposition d'une API publique (optionnel)
   * Permet de contrôler le parallaxe depuis l'extérieur si nécessaire
   */
  window.NomarbleParallax = {
    init: init,
    destroy: destroy,
    updateParallax: updateParallax
  };

})();
